/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

/**
 * ShowloadingContinuetodelivery Input Action
 */
export class ShowloadingContinuetodeliveryInput implements Msdyn365.IActionInput {
    //  Construct the input needed to run the action
    constructor() {}

    // a cache object type and an appropriate cache key
    public getCacheKey = () => `ShowloadingContinuetodeliveryInput`;
    public getCacheObjectType = () => 'ShowloadingContinuetodeliveryInput';
    public dataCacheType = (): Msdyn365.CacheType => 'application';
}

// Create a data model here or import one to capture the response of the action
export interface IShowloadingContinuetodeliveryData {
    customersApiLoadingCase: boolean;
}

/**
 *  Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new ShowloadingContinuetodeliveryInput();
};

/**
 *  Use this function to call your action and process the results as needed
 */
async function action(input: ShowloadingContinuetodeliveryInput, ctx: Msdyn365.IActionContext): Promise<IShowloadingContinuetodeliveryData> {

    return { customersApiLoadingCase: false };
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IShowloadingContinuetodeliveryData>>action,
    // Give your data action a unique id
    id: 'ShowloadingContinuetodelivery',
    input: createInput
    // Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
